export default {
    contactsList: {
        actions: 'Actions',
        add: 'New',
        allTab: 'All',
        bulkAction: 'Bulk Action',
        delete: 'Delete',
        deleteModal: {
            header: 'Delete contacts',
            message: 'Are you sure you want to delete the selected contacts?',
        },
        edit: 'Edit',
        email: 'Email',
        firstName: 'First Name',
        fullName: 'Full Name',
        lastName: 'Last Name',
        locale: 'Language',
        noContacts: 'No contacts.',
        wouldYouLikeToAddOne: 'Would you like to add one?',
        pageTitle: 'Contacts',
        phone: 'Phone',
        search: 'Search...',
        selectAll: 'Select All',
        sendMassSms: 'Send SMS',
        consent: 'Consent',
        createPayment: 'Create payment',
        successes: {
            deleted: 'Contact deleted successfully. | Contacts deleted successfully.',
        },
        errors: {
            deleting: 'An error occured. Contact could not deleted. | An error occured. Contacts could not not deleted.',
        },
        subscribed: 'Subscribed',
        subscribedTab: 'Subscribed',
        unsubscribedTab: 'Unsuscribed',
        goToConversation: 'Go to conversation',
        createConversation: 'Create conversation',
        createAppointment: 'Create appointment',
    },
    contactModal: {
        addTitle: 'New Contact',
        editTitle: 'Edit Contact',
        civility: 'Civility',
        firstName: 'First Name',
        lastName: 'Last Name',
        locale: 'Locale',
        subscribedSms: 'Subscribed to SMS',
        subscribedEmail: 'Subscribed to emails',
        maySendSms: 'Accepts SMS communications',
        mayNotSendSms: 'Doesn\'t want SMS communications',
        maySendEmail: 'Accepts email communications',
        mayNotSendEmail: 'Doesn\'t want email communications',
        onlyUserMayResubscribe: 'Only a contact may ask to receive this type of communications again.',
        notes: 'Notes',
        sms: 'SMS',
        email: 'Email',
        communicationPreference: 'Communication preference',
        phone: 'Phone',
        phoneNumbers: 'Phone numbers',
        validate: 'Validate',
        addPhone: 'Add phone',
        deletePhone: 'Delete phone',
        choose: 'Choose...',
        notifications: {
            success: {
                create: 'Your contact was created successfully.',
                update: 'Your contact was updated successfully.',
            },
            errors: {
                createContact: 'An error occured while creating the contact.',
                updateContact: 'An error occured while updating the contact.',
                fetchContact: 'An error occured while refreshing the contact information.',
                createPhone: 'An error occured while creating the phone numbers.',
                editPhone: 'An error occured while saving the phone numbers.',
            },
        },
        validationTooltip: {
            userMustBeSaved: 'Contact must first be saved',
            alreadyValidated: 'Already validated',
        },
    },
    phones: {
        allInvalid: 'No valid mobile phone',
        invalid: 'Not a valid mobile phone',
        notValidated: 'The number hasn\'t been verified yet',
        none: 'No phone',
    },
    email: {
        none: 'No email',
    },
    sendMassSmsModal: {
        title: 'Send Mass SMS',
        cancel: 'Cancel',
        sending: 'SMS sending in progress...',
    },
};
